import * as React from "react";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import {Boxed} from "../../../hiberUiKit/src/molecules/Boxed/Boxed";
import PageHeaderView from "../../body/PageHeaderView";
import PageContentView from "../../body/PageContentView";
import CreateBrandForm from "./form/create/CreateBrandForm";
import Routes from "../../../navigation/route/Route";

type Props = RouteComponentProps<any>;

/**
 * Create brand.
 */
class BrandCreate extends React.PureComponent <Props, {}> {

	constructor(props: Props) {
		super(props);
		this.onSuccess = this.onSuccess.bind(this);
		this.onCancel = this.onCancel.bind(this);
	}

	render() {
		return (
			<Boxed>
				<PageHeaderView header={"Create new brand"}/>
				<PageContentView>
					<CreateBrandForm onSuccess={this.onSuccess} onCancel={this.onCancel}/>
				</PageContentView>
			</Boxed>
		);
	}

	/**
	 * On successfully added brand.
	 */
	private onSuccess() {
		this.props.history.push(Routes.BrandList);
	}

	/**
	 * On cancel click.
	 * Redirect to previous page.
	 */
	private onCancel() {
		this.props.history.goBack();
	}
}

export default withRouter(BrandCreate);